var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c("div", { staticClass: "bg-surface-secondary w-100" }, [
      _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
        _c("div", { staticClass: "container-fluid py-3" }, [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
                _c("div", [
                  _c("button", {
                    staticClass: "btn-close text-xs",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.go(-1)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vr opacity-20 my-1" }),
                _vm._v(" "),
                _c("div", [
                  _c("h1", { staticClass: "h4 ls-tight" }, [
                    _vm._v(
                      "Paquete - " + _vm._s(_vm.data.type) + _vm._s(_vm.data.id)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-sm text-muted mb-0" }, [
                    _vm._v(
                      "Administre los roles de su cuenta y otorgue a sus\n                            administradores solo los permisos necesarios."
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
        _c(
          "div",
          { staticClass: "container-fluid vstack gap-5" },
          [
            _vm.loading
              ? _c("div", { staticClass: "w-100 pt-5" }, [
                  _c("div", { staticClass: "text-center" }, [
                    _c(
                      "div",
                      {
                        staticClass: "spinner-border text-primary",
                        attrs: { role: "status" },
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Loading..."),
                        ]),
                      ]
                    ),
                  ]),
                ])
              : _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Cliente: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "form-control form-control-sm text-muted bg-white",
                                staticStyle: {
                                  "font-size": "11px",
                                  height: "31px",
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _vm.data.user
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "text-decoration-none",
                                        attrs: {
                                          to: {
                                            name: "UserDetail",
                                            params: {
                                              role: _vm.data.user.role.name,
                                              id: _vm.data.user.id,
                                            },
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(_vm.data.user.name) +
                                            " - " +
                                            _vm._s(
                                              "" +
                                                _vm.data.user.type +
                                                _vm.data.user.id
                                            ) +
                                            "\n                                        "
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-square-arrow-up-right",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Valor: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              staticClass:
                                "form-control form-control-sm text-muted bg-white",
                              staticStyle: {
                                "font-size": "11px",
                                height: "31px",
                                display: "flex",
                                "align-items": "center",
                              },
                              attrs: { type: "text", readonly: "" },
                              domProps: {
                                value: Number(_vm.data.value || 0).toFixed(2),
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Remitente: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              staticClass:
                                "form-control form-control-sm text-muted bg-white",
                              staticStyle: {
                                "font-size": "11px",
                                height: "31px",
                                display: "flex",
                                "align-items": "center",
                              },
                              attrs: { type: "text", readonly: "" },
                              domProps: { value: _vm.data.shipper },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Embalaje: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              staticClass:
                                "form-control form-control-sm text-muted bg-white",
                              staticStyle: {
                                "font-size": "11px",
                                height: "31px",
                                display: "flex",
                                "align-items": "center",
                              },
                              attrs: { type: "text", readonly: "" },
                              domProps: {
                                value: _vm.data.packing
                                  ? _vm.data.packing.name
                                  : "",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Peso: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              staticClass:
                                "form-control form-control-sm text-muted bg-white",
                              staticStyle: {
                                "font-size": "11px",
                                height: "31px",
                                display: "flex",
                                "align-items": "center",
                              },
                              attrs: { type: "text", readonly: "" },
                              domProps: {
                                value: Number(_vm.data.weight || 0).toFixed(2),
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Dimensiones: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              staticClass:
                                "form-control form-control-sm text-muted bg-white",
                              staticStyle: {
                                "font-size": "11px",
                                height: "31px",
                                display: "flex",
                                "align-items": "center",
                              },
                              attrs: { type: "text", readonly: "" },
                              domProps: {
                                value:
                                  Number(_vm.data.lengthy || 0).toFixed(2) +
                                  " x " +
                                  Number(_vm.data.width || 0).toFixed(2) +
                                  " x " +
                                  Number(_vm.data.tall || 0).toFixed(2),
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Descripción: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _vm.data.description[0]
                                          ? _c(
                                              "div",
                                              _vm._g(
                                                _vm._b({}, "div", attrs, false),
                                                on
                                              ),
                                              [
                                                _c("input", {
                                                  staticClass:
                                                    "form-control form-control-sm text-muted bg-white",
                                                  staticStyle: {
                                                    "font-size": "11px",
                                                    height: "31px",
                                                    display: "flex",
                                                    "align-items": "center",
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.data.description[0],
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "small",
                                  _vm._l(
                                    _vm.data.description,
                                    function (description, key) {
                                      return _c("div", { key: key }, [
                                        _vm._v(_vm._s(description)),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Tracking: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              staticClass:
                                "form-control form-control-sm text-muted bg-white",
                              staticStyle: {
                                "font-size": "11px",
                                height: "31px",
                                display: "flex",
                                "align-items": "center",
                              },
                              attrs: { type: "text", readonly: "" },
                              domProps: { value: _vm.data.tracking },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Impuesto: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              staticClass:
                                "form-control form-control-sm text-muted bg-white",
                              staticStyle: {
                                "font-size": "11px",
                                height: "31px",
                                display: "flex",
                                "align-items": "center",
                              },
                              attrs: { type: "text", readonly: "" },
                              domProps: {
                                value: _vm.data.tax
                                  ? Number(
                                      _vm.data.tax.value * 100 || 0
                                    ).toFixed(2) + "%"
                                  : "",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Piezas: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              staticClass:
                                "form-control form-control-sm text-muted bg-white",
                              staticStyle: {
                                "font-size": "11px",
                                height: "31px",
                                display: "flex",
                                "align-items": "center",
                              },
                              attrs: { type: "text", readonly: "" },
                              domProps: { value: _vm.data.pieces },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Peso Volumétrico: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              staticClass:
                                "form-control form-control-sm text-muted bg-white",
                              staticStyle: {
                                "font-size": "11px",
                                height: "31px",
                                display: "flex",
                                "align-items": "center",
                              },
                              attrs: { type: "text", readonly: "" },
                              domProps: {
                                value: Number(
                                  _vm.data.volumetric_weight || 0
                                ).toFixed(2),
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Creado Por: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "form-control form-control-sm text-muted bg-white",
                                staticStyle: {
                                  "font-size": "11px",
                                  height: "31px",
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _vm.data.user_created
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "text-decoration-none",
                                        attrs: {
                                          to: {
                                            name: "UserDetail",
                                            params: {
                                              role: _vm.data.user_created.role
                                                .name,
                                              id: _vm.data.user_created.id,
                                            },
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(_vm.data.user_created.name) +
                                            " - " +
                                            _vm._s(
                                              "" +
                                                _vm.data.user_created.type +
                                                _vm.data.user_created.id
                                            ) +
                                            "\n                                        "
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-square-arrow-up-right",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Actualizado Por: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "form-control form-control-sm text-muted bg-white",
                                staticStyle: {
                                  "font-size": "11px",
                                  height: "31px",
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _vm.data.user_updated
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "text-decoration-none",
                                        attrs: {
                                          to: {
                                            name: "UserDetail",
                                            params: {
                                              role: _vm.data.user_updated.role
                                                .name,
                                              id: _vm.data.user_updated.id,
                                            },
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(_vm.data.user_updated.name) +
                                            " -" +
                                            _vm._s(
                                              "" +
                                                _vm.data.user_updated.type +
                                                _vm.data.user_updated.id
                                            ) +
                                            "\n                                        "
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-square-arrow-up-right",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Creado: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              staticClass:
                                "form-control form-control-sm text-muted bg-white",
                              staticStyle: {
                                "font-size": "11px",
                                height: "31px",
                                display: "flex",
                                "align-items": "center",
                              },
                              attrs: { type: "text", readonly: "" },
                              domProps: {
                                value: _vm._f("DATETIME")(_vm.data.created_at),
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Actualizado: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              staticClass:
                                "form-control form-control-sm text-muted bg-white",
                              staticStyle: {
                                "font-size": "11px",
                                height: "31px",
                                display: "flex",
                                "align-items": "center",
                              },
                              attrs: { type: "text", readonly: "" },
                              domProps: {
                                value: _vm._f("DATETIME")(_vm.data.updated_at),
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("AWB: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              staticClass:
                                "form-control form-control-sm text-muted bg-white",
                              staticStyle: {
                                "font-size": "11px",
                                height: "31px",
                                display: "flex",
                                "align-items": "center",
                              },
                              attrs: { type: "text", readonly: "" },
                              domProps: {
                                value: _vm.data.awb ? _vm.data.awb.awb : "",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("HAWB: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              staticClass:
                                "form-control form-control-sm text-muted bg-white",
                              staticStyle: {
                                "font-size": "11px",
                                height: "31px",
                                display: "flex",
                                "align-items": "center",
                              },
                              attrs: { type: "text", readonly: "" },
                              domProps: {
                                value: _vm.data.hawb ? _vm.data.hawb.hawb : "",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Archivos Adjuntos: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [_c("div", { staticClass: "py-3" })]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      _vm._l(_vm.data.files, function (item, index) {
                        return _c(
                          "div",
                          { staticClass: "col-lg-1 col-md-2 col-sm-3 col-4" },
                          [
                            _c("img", {
                              staticClass: "img-fluid",
                              attrs: { src: "" + item.path },
                            }),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
            _vm._v(" "),
            _c("payments"),
            _vm._v(" "),
            _c("history"),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }